export const NOTIFICATION_BOX_ENTER_DELAY = 250;
export const NOTIFICATION_BOX_INITIAL_DELAY = 150;
export const NOTIFICATION_BOX_MIN_HEIGHT = {
  xs: '104px',
  sm: '106px',
  md: '134px',
  lg: '134px',
  xl: '140px'
};
export const NOTIFICATION_BOX_MAX_HEIGHT = {
  xs: '392px',
  sm: '400px',
  md: '412px',
  xl: '440px'
};
export const NOTIFICATION_CLOSE_BUTTON_SIZE = {
  xs: '40px',
  md: '48px',
  xl: '52px'
};
export const NOTIFICATION_ICON_SIZE = {
  xs: '16px',
  md: '20px',
  lg: '24px'
};
export const NOTIFICATION_WIDTH = {
  xs: 'calc(100vw - 32px)',
  sm: '320px',
  md: '400px',
  xl: '480px'
};
export const NOTIFICATION_BORDER_RADIUS = '5px';
export const NOTIFICATION_BORDER_WIDTH = {
  xs: '4px',
  md: '8px'
};
export const NOTIFICATION_BORDER_HEIGHT = {
  xs: '4px',
  md: '8px'
};
export const NOTIFICATION_PADDING = {
  xs: '16px 48px 20px 36px',
  md: '20px 52px 24px 52px',
  lg: '20px 56px 24px 56px'
};
export const NOTIFICATION_CONDENSED_HORIZONTAL_PADDING = {
  xs: '20px',
  md: '28px',
  xl: '32px'
};
export const NOTIFICATION_ICON_LEFT_POSITION = {
  xs: '12px',
  md: '24px'
};
export const NOTIFICATION_ICON_TOP_POSITION = {
  xs: '16px',
  md: '20px',
  xl: '20px'
};
export const NOTIFICATION_MARGIN = {
  xs: '16px',
  md: '24px'
};
export const NOTIFICATION_DELAY = 4000;
export const NOTIFICATION_CLOSE_DURATION = 600;